/** Domain vocabulary shared by every app and worker. SRS §2. */

export const ORDER_STATUSES = [
  'pending_payment',
  'placed',
  'accepted',
  'preparing',
  'ready',
  'delivered',
  'cancelled',
  'refunded',
] as const
export type OrderStatus = (typeof ORDER_STATUSES)[number]

/** Statuses the kitchen actively works. Drives the KDS columns (FR-KDS-1). */
export const OPEN_ORDER_STATUSES = ['placed', 'accepted', 'preparing', 'ready'] as const

export const ORDER_CHANNELS = ['kiosk', 'qr', 'pos', 'web'] as const
export type OrderChannel = (typeof ORDER_CHANNELS)[number]

export const ORDER_TYPES = ['dine_in', 'takeaway'] as const
export type OrderType = (typeof ORDER_TYPES)[number]

export const PAYMENT_METHODS = [
  'cash',
  'bkash_manual',
  'nagad_manual',
  'rocket_manual',
  'card_manual',
] as const
export type PaymentMethod = (typeof PAYMENT_METHODS)[number]

export const PAYMENT_STATUSES = ['pending', 'confirmed', 'failed', 'refunded'] as const
export type PaymentStatus = (typeof PAYMENT_STATUSES)[number]

/** FR-AUTH-1. Ordered most to least privileged. */
export const ROLES = [
  'owner',
  'admin',
  'manager',
  'cashier',
  'kitchen_staff',
  'inventory_staff',
] as const
export type Role = (typeof ROLES)[number]

export const SPICE_LEVELS = [0, 1, 2, 3] as const
export type SpiceLevel = (typeof SPICE_LEVELS)[number]

export const LOCALES = ['en', 'bn'] as const
export type Locale = (typeof LOCALES)[number]

export const INVENTORY_TRANSACTION_TYPES = [
  'purchase',
  'deduction',
  'waste',
  'adjustment',
  'refund_restore',
] as const
export type InventoryTransactionType = (typeof INVENTORY_TRANSACTION_TYPES)[number]

export const INGREDIENT_UNITS = ['g', 'ml', 'pcs'] as const
export type IngredientUnit = (typeof INGREDIENT_UNITS)[number]

export const COUPON_TYPES = ['percent', 'fixed'] as const
export type CouponType = (typeof COUPON_TYPES)[number]

export const VAT_MODES = ['exclusive', 'inclusive'] as const
export type VatMode = (typeof VAT_MODES)[number]

/** Defaults; overridable per branch in settings (FR-ADM-1). */
export const DEFAULTS = {
  vatRateBp: 500,
  vatMode: 'exclusive' as VatMode,
  kioskIdleTimeoutSec: 60,
  defaultPrepTimeSec: 480,
  maxLineQuantity: 99,
  maxNoteLength: 200,
  orderStatusTokenTtlSec: 24 * 60 * 60,
} as const
